



































import {Component, Prop, Vue} from 'vue-property-decorator';
import ChatbotAvatar from '@/components/images/ChatbotAvatar.vue';
import {Conversation, FormType, Output} from '@/types/asix';
import {AsixModule} from '@/store/modules/asix';
import {AppModule} from '@/store/modules/app';

@Component({
  components: {
    ChatbotAvatar,
  },
})
export default class TextBubble extends Vue {
  private textTypes = [
    FormType.Text,
    FormType.RichText,
    FormType.HeadText,
    FormType.ImgText,
  ]

  @Prop({required: true})
  private conversation!: Conversation;

  @Prop({default: '_blank'})
  private target!: string;

  get formType() {
    return FormType
  }

  get texts(): Output[] {
    return this.conversation.outList.filter((o: Output) => this.textTypes.includes(o.expression_form))
  }

  get linkItems(): Output[] {
    return this.conversation.outList.filter((o: Output) => o.expression_form === FormType.Link)
  }

  get isLast(): boolean {
    return AsixModule.latestBotConv ? AsixModule.latestBotConv.id === this.conversation.id : false
  }

  public ariaLabel(linkItem: any): string {
    return linkItem && linkItem.text ? linkItem.text : ''
  }

  public hasLinkAttr(linkItem: any) {
    return linkItem && linkItem.text
  }

  public onIntersect(entries: any, observer: any) {
    if (this.isLast) {
      AppModule.setIsShowMoreMsg(!entries[0].isIntersecting)
    }
  }
}
